import React from 'react';
import PropTypes from 'prop-types';

import ContributeButton from '../../../../components/global/ContributeButton/ContributeButton';
import UploadIcon from '../../../../components/icons/UploadIcon';
import ShareUrlClipboardButton from '../../../../components/global/ShareUrlIcons/ShareUrlClipboardButton';
import ListingCardThumbnailActionMenu from '../../../pro/components/ListingCardTemplate/ListingCardThumbnailActionMenu';

const propTypes = {
  albumFolderId: PropTypes.string,
  albumId: PropTypes.string,
  url: PropTypes.string,
  quote: PropTypes.string,
};

const WebGalleryThumbnailActions = ({ albumFolderId, albumId, url, quote }) => {
  return (
    <ListingCardThumbnailActionMenu>
      <ContributeButton albumFolderId={albumFolderId} albumId={albumId}>
        {({ onClick }) => {
          return (
            <a
              href="#"
              onClick={event => {
                event.preventDefault();
                onClick();
              }}
              className="dropdown-item d-flex align-items-center"
            >
              <UploadIcon size={16} className="mr-1" /> Upload Photos
            </a>
          );
        }}
      </ContributeButton>

      <ShareUrlClipboardButton
        className="dropdown-item d-flex align-items-center"
        text={`${quote} ${url}`}
        iconProps={{ size: 16 }}
      >
        <span className="ml-1">Copy Share URL</span>
      </ShareUrlClipboardButton>
    </ListingCardThumbnailActionMenu>
  );
};

WebGalleryThumbnailActions.propTypes = propTypes;

export default WebGalleryThumbnailActions;
